import { Component } from '@angular/core';
import { AbstractFieldDirective } from '../abstract-field.directive';
import { FieldOption } from '../../model/field-option.interface';
import { toTextValue } from '../../tool/field.function';

@Component({
  selector: 'app-list-field',
  templateUrl: './list-field.component.html',
  styleUrls: ['./list-field.component.scss']
})
export class ListFieldComponent extends AbstractFieldDirective {

  protected get value(): undefined | string {
    return this.field?.value || undefined;
  }
  protected get options(): FieldOption[] {
    return this.field?.options || [];
  }

  add(): void {
    const options = this.options;
    options.push({ label: '' });
    this.updateOptions(options);
  }
  remove(index: number): void {
    const options = this.options;
    options.splice(index, 1);
    this.updateOptions(options);
  }

  toDown(index: number): void {
    const options = this.options;
    if (index < options.length - 1) {
      [options[index], options[index + 1]] = [options[index + 1], options[index]];
      this.updateOptions(options);
    }
  }
  toUp(index: number): void {
    const options = this.options;
    if (index > 0) {
      [options[index], options[index - 1]] = [options[index - 1], options[index]];
      this.updateOptions(options);
    }
  }

  protected updateValue(option?: null | string): void {
    if (!this.field)
      return;
    const newValue = toTextValue(option);
    if (this.field.value === newValue)
      return;
    this.field.value = newValue;
    this.fieldChange.emit(this.field);
  }
  protected updateOption(index: number, option?: null | string): void {
    if (!this.field)
      return;
    const newValue = toTextValue(option);
    if (this.field.options?.[index]?.label === newValue)
      return;
    this.field.options[index].label = newValue;
    this.fieldChange.emit(this.field);
  }

  private updateOptions(options: FieldOption[] = []): void {
    if (!this.field)
      return;
    const newOptions = JSON.stringify(options);
    const oldOptions = JSON.stringify(this.field.options);
    if (oldOptions === newOptions)
      return;
    this.field.options = [...options];
    this.fieldChange.emit(this.field);
  }

}
